import React from 'react';
import './App.scss';

function Experience() {
  return (
    <>
      <div className='title-box'>
        <p className='subtitle'>Work Experience</p>
        <p className='title'>Experiências</p>
      </div>
      <div className='box-experience box-0'>
        <div className='header'>
          <div className='icons'>
            <div className='icon-1'></div><div className='icon-2'></div><div className='icon-3'></div>
          </div>
          <p className='title'>Analista de software Pleno</p>
          <div style={{ width: '50px' }}>
          </div>
        </div>
        <p>Ingressei na Vidya Technology como estagiário e fui efetivado como Desenvolvedor Full-Stack após concluir minha formação acadêmica.
          Atualmente trabalho no desenvolvimento do sistema Web e Mobile, utilizando Vue.js com Vuetify (Web) e Vue3 com Quasar (Mobile). Tenho
          experiência em Java (Spring), abrangendo bancos SQL e noSQL (PosgreSQL, CouchDB, PouchDB), com foco em Integração entre os sistemas e
          replicação de bancos de dados nos sistemas Web (SQL) e mobile (noSQL).
        </p>
        <p>Além das responsabilidades técnicas, treinei estagiários para uma integração eficiente no sistema e na equipe. Destaco-me na otimização de
          código, tratamento de dados, desenvolvimento de layouts responsivos e implementação de melhorias a nível de arquitetura, desempenho e
          boas práticas. Tenho experiência em bibliotecas 3D como Three.js e Autodesk Forge, lidero testes de software, correção de bugs e elaboração
          de documentação.
        </p>
        <p>No ambiente colaborativo, utilizo Linux, GIT e GitLab, aplicando a metodologia Scrum, A comunicação em inglês é constante em todos os
          processos. Além disso, tenho experiência com AWS (Amazon Web Services) e Docker, e integração com serviços de IA, agregando eficiência
          ao ambiente de desenvolvimento.
        </p>
        <div className='tags'>
          <span>Vue</span>
          <span>Java</span>
          <span>Three.js</span>
          <span>PostgresSQL</span>
          <span>CouchDB</span>
          <span>AWS</span>
          <span>IA</span>
        </div>
      </div>
      <div className='box-experience box-1'>
        <div className='header'>
          <div className='icons'>
            <div className='icon-1'></div><div className='icon-2'></div><div className='icon-3'></div>
          </div>
          <p className='title'>Desenvolvedor Front-End Júnior II</p>
          <div style={{ width: '50px' }}>
          </div>
        </div>
        <p>Desenvolvedor Front-End especializado em projetos React utilizando Typescript e JavaScript. Experiência em ambientes virtualizados com
          Docker (CentoOS 7, Linux). Proficiente na implementação de Redux, GraphQL, SASS e Styled Components para otimização e consistência na
          estilização.
        </p>
        <p>Destaco a criação de painéis administrativos com dashboards e gráficos, otimizando eficientemente o sistema para lidar com grandes volumes
          de dados, como gestão de clientes, atendentes e administradores do sistema, lidando com milhares de mensagens e processos ocorrendo
          simultaneamente, garanto que o sistema lide com esses dados da melhor forma possível, gerenciando o consumo de memória e a integridade
          dos dados do WhatsApp, destacando-se especialmente no sistema do PecaZap.
        </p>
        <p>Durante minha experiência, utilizei a metodologia Scrum, Git com Git lab, realizei o code review dos outros desenvolvedores (Front-end e
          Backend), criei protótipos e apresentei para a equipe a fim de definir o'que seria melhor para o sistema, reuniões de feedback mensal,
          pesquisas de bibliotecas e ferramentas que poderiam ser implementadas no sistema
        </p>
        <div className='tags'>
          <span>React</span>
          <span>TypeScript</span>
          <span>Redux</span>
          <span>Graphql</span>
        </div>
      </div>
      <div className='box-experience box-2'>
        <div className='header'>
          <div className='icons'>
            <div className='icon-1'></div><div className='icon-2'></div><div className='icon-3'></div>
          </div>
          <p className='title'>(TCC) Ser+</p>
          <div style={{ width: '50px' }}>
          </div>
        </div>
        <p>Liderança na estruturação, documentação e desenvolvimento do sistema responsável pelo controle de projetos sociais e de extensão da
          Universidade Católica de Brasília. Realizei o levantamento de requisitos em colaboração direta com o cliente, desenvolvi o protótipo do
          sistema utilizando Figma e conceitos de UI/UX, e desempenhei um papel ativo no desenvolvimento do front-end, utilizando React, Next.js,
          MaterialUI e Axios.
        </p>
        <p>Contribuí ativamente na escolha das tecnologias, liderando a coordenação e treinamento da equipe de front-end, compartilhando
          conhecimentos sobre as ferramentas mencionadas. Além disso, prestei suporte à equipe de back-end (Node) do sistema. Desde janeiro de
          2023, o sistema está em operação, sendo utilizado para o controle e gerenciamento de todos os estudantes da universidade.
        </p>
        <div className='tags'>
          <span>React</span>
          <span>TypeScript</span>
          <span>Redux</span>
          <span>Node.js</span>
          <span>Axios</span>
          <span>PostgreSQL</span>
        </div>
      </div>
    </>
  );
}

export default Experience;
